import { render } from "./CFANavBottom.vue?vue&type=template&id=66628c07&scoped=true"
import script from "./CFANavBottom.vue?vue&type=script&lang=js"
export * from "./CFANavBottom.vue?vue&type=script&lang=js"

import "./CFANavBottom.vue?vue&type=style&index=0&id=66628c07&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66628c07"]])

export default __exports__